import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplateFieldsMutation, UpdateTemplateFieldsMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplateFieldsDocument } from '@/graphql/generated/graphql';
export type TemplateFieldUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  ScreenId?: string
  Name?: string
  Label?: string
  Type?: string
  Required?: boolean
  Placeholder?: string
  HelpText?: string
  Options?: string[]
  Order?: number
  AiSuggestionEnabled?: boolean
  AiSuggestionKey?: string
  UilmHelpTextKey?: string
  UilmLabelKey?: string
  UilmOptionsKeys?: string[]
  UilmPlaceholderKey?: string
  Conditions?: string
}

export type UpdateTemplateFieldResponse = {
  data: {
    updateTemplateFields: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplateField = () => {
  const mutation = useMutation({
    mutationKey: ['update-template-field'],
    mutationFn: (variables: TemplateFieldUpdateInput) => {
      return graphqlClient.request<UpdateTemplateFieldsMutation>(UpdateTemplateFieldsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplateField: mutation.mutate,
    updateTemplateFieldAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_FIELD_MUTATION = UpdateTemplateFieldsDocument;
